/**
 * OrcaloopsArchiveRpcClient — AtomRpc integration for the customer's own
 * orcaloops-archive endpoints (OL-152).
 *
 * Every method in the group runs under `AuthMiddleware`, so the Clerk session
 * token has to ride the request: `makeTokenGetterLayer()` is what attaches it.
 * Neither payload carries a customer id — the server resolves ownership from
 * `CurrentActor` — so an unauthenticated client has no way to name a tenant and
 * is simply refused.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { OrcaloopsArchiveRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class OrcaloopsArchiveRpcClient extends AtomRpc.Tag<OrcaloopsArchiveRpcClient>()(
  "OrcaloopsArchiveRpcClient",
  {
    group: OrcaloopsArchiveRpcs,
    protocol: makeRpcClientLayer(OrcaloopsArchiveRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
